import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Components/Home/Home";
import Layout from "./Components/Layout/Layout";
import Transition from "./Components/Transition";
import { AnimatePresence, motion } from "framer-motion";
import About from "./Components/About";
import Services from "./Components/Services";
import Work from "./Components/Work";
import Testimonials from "./Components/Testimonials";
import Contact from "./Components/Contact";
import { useEffect, useState } from "react";

function App() {
  const location = useLocation();
  const [locationPath, setLocationPath] = useState("");
  useEffect(() => {
    setLocationPath(location.pathname);
  }, [location.pathname]);
  return (
    <Layout>
      <AnimatePresence mode="wait">
        <motion.div key={locationPath} className="h-full">
          <Transition />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/work" element={<Work />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </Layout>
  );
}

export default App;
